export const siteMeta = {
  name: "蝌蚪爆料",
  slogan: "一手线索的起点",
  tagline: "不追风、不编造，每一条线索都认真核实后呈现。",
  email: "tips@kedoubaoliao.cn",
  hotline: "400-826-3018",
  workTime: "线索受理：每日 09:00 - 22:00",
  wechat: "kedou_tips",
  established: "2021",
};

export const stats = [
  { label: "累计收到线索", value: "38,600+", unit: "条" },
  { label: "完成核实并公开", value: "1,240", unit: "条" },
  { label: "覆盖城市", value: "217", unit: "座" },
  { label: "投稿人隐私零泄露", value: "0", unit: "起" },
];

export const categories = [
  {
    id: "consumer",
    name: "消费维权",
    desc: "预付卡跑路、虚假宣传、售后推诿等与钱包直接相关的线索。",
    icon: "ri-shield-star-line",
    count: 386,
  },
  {
    id: "business",
    name: "商业观察",
    desc: "供应链、加盟、直播选品、平台规则背后的真实运作方式。",
    icon: "ri-line-chart-line",
    count: 254,
  },
  {
    id: "workplace",
    name: "职场一线",
    desc: "招聘套路、离职纠纷、用工规范等来自从业者的一手见闻。",
    icon: "ri-briefcase-line",
    count: 197,
  },
  {
    id: "industry",
    name: "行业调查",
    desc: "垂直领域的灰色地带、成本结构与信息不对称的调查线索。",
    icon: "ri-search-eye-line",
    count: 168,
  },
  {
    id: "livelihood",
    name: "环境民生",
    desc: "居住、出行、公共空间与普通人日常生活相关的现实问题。",
    icon: "ri-home-smile-line",
    count: 143,
  },
  {
    id: "campus",
    name: "校园信息",
    desc: "培训机构、校园周边经营、升学服务中的不规范现象。",
    icon: "ri-book-open-line",
    count: 92,
  },
];

export const credibilityMap: Record<string, { label: string; className: string }> = {
  verified: { label: "已核实", className: "bg-primary-500 text-background-50" },
  cross: { label: "多方印证", className: "bg-accent-500 text-foreground-950" },
  pending: { label: "核实中", className: "bg-secondary-500 text-background-50" },
};

export const leads = [
  {
    id: "fitness-card-refund",
    title: "连锁健身房预付卡风控调查：三城门店同步闭店，余额退款无门",
    category: "consumer",
    summary:
      "多位会员与在职教练向本栏目反映，同一品牌在三个城市的门店在一周内先后停业，储值卡余额与私教课包均无法退款，员工薪资亦被拖欠。",
    cover:
      "https://readdy.ai/api/search-image?query=Closed%20modern%20gym%20interior%20with%20empty%20treadmills%20and%20dim%20overhead%20lighting%2C%20abandoned%20front%20desk%2C%20cold%20muted%20tones%2C%20documentary%20photography%20style%2C%20cinematic%20and%20melancholic%20atmosphere&width=800&height=600&seq=kedou-lead-fitness-01&orientation=landscape",
    source: "匿名投稿 · 前门店主管",
    date: "2026-08-28",
    readTime: "8 分钟",
    credibility: "verified",
    tags: ["预付卡", "健身行业", "退款难"],
    keyPoints: [
      "同一品牌三个城市共 9 家门店在一周内集中停业，闭店时间高度同步。",
      "门店在停业前两周仍在大规模推销两年期储值卡与私教课包。",
      "在职教练与前台员工被拖欠 2 至 3 个月薪资，社保断缴。",
      "会员自发登记维权金额已超过 420 万元，涵盖 1100 余名会员。",
    ],
    content: [
      "从今年五月开始，投稿人所在的连锁健身品牌陆续出现异常。最先变化的是排班表：原本固定的团课时段被悄然取消，替换成一对一的私教体验课。投稿人回忆，那段时期门店的考核重点从续卡率转向了新客储值金额。",
      "七月下旬，门店做过一次小范围的系统维护，会员系统短暂无法登录。等到八月恢复时，不少会员发现自己的剩余课次被合并计算，原本清晰的余额被拆分成了含有效期的项目。",
      "八月最后一周，三个城市的门店几乎在同一时间贴出停业通知，口径一致地写着「设备检修」。此后通知被撤下，联系电话无人接听，品牌方的官方账号也停止了更新。",
      "投稿人表示，闭店前两周门店仍在主推两年期储值卡与打包私教课，销售话术明确要求「今天不定明天就恢复原价」。多名会员提供的付款记录显示，最后一笔储值与停业之间最短仅相隔四天。",
      "在采访过程中，我们也联系了另外两名来自不同城市的在职员工，他们描述的闭店节奏与投稿人基本一致，包括停业前突击推销、内部突然冻结提成、以及管理层集体失联。基于三条独立来源的相互印证，本条线索被标记为「已核实」。",
      "需要说明的是，本条内容聚焦于可被多方交叉验证的事实经过，不针对任何具体个人作出评价。相关会员的维权途径、合同条款与法律依据，我们已在文末的补充说明中做了整理。",
    ],
  },
  {
    id: "live-stream-beef",
    title: "直播间「原切牛肉」供应链还原：从选品会到贴牌包装的完整流程",
    category: "business",
    summary:
      "一位曾参与直播选品的采购从业者还原了「原切」话术的产生过程，并提供了选品会记录与包装标签的比对材料。",
    cover:
      "https://readdy.ai/api/search-image?query=Food%20packaging%20facility%20with%20sealed%20meat%20packages%20on%20a%20stainless%20steel%20conveyor%2C%20cold%20blue%20grey%20lighting%2C%20industrial%20documentary%20photography%2C%20clinical%20and%20sterile%20mood%2C%20high%20detail&width=800&height=600&seq=kedou-lead-livestream-02&orientation=landscape",
    source: "匿名投稿 · 前直播选品",
    date: "2026-08-21",
    readTime: "9 分钟",
    credibility: "cross",
    tags: ["直播电商", "食品安全", "选品"],
    keyPoints: [
      "选品会记录显示，部分产品的原料等级与直播话术存在明显偏差。",
      "同一批次产品会分别贴上不同的包装与品牌标识。",
      "供应商被要求在直播前统一口径，避免提及具体原料部位。",
    ],
    content: [
      "投稿人在一家直播机构的选品部门工作了将近一年。据其描述，选品会的核心并不是筛选质量，而是计算毛利空间与话术的可包装程度。",
      "一份被保留下来的选品记录显示，某款牛排产品在内部备注中标注为「重组工艺」，但在直播脚本里，对应的表述被统一改成了「原切」「整块」。这两个词带来的转化率差异，是选品会反复讨论的重点。",
      "包装环节是另一处关键。投稿人称，同一批次的产品常常会出现多个品牌标识的包装袋，最终以哪个品牌上架，取决于当天直播间的排期与价格策略。",
      "供应商方面则被要求在直播开始前接受一次「口径培训」，主要内容是避免提及原料的具体部位与加工方式。投稿人提供了两段沟通记录的截图，其中的措辞与直播话术可以相互对应。",
      "我们随后联系了两位曾与该机构合作过的供应商，他们对选品流程的描述与投稿人接近。由于目前仍缺少第三方检测结论，本条线索标记为「多方印证」，我们将继续补充材料。",
    ],
  },
  {
    id: "ghost-kitchen",
    title: "同一地址挂靠多个品牌：外卖「集中出餐点」实地观察记录",
    category: "industry",
    summary:
      "连续三周的实地观察发现，某出餐点在平台上以十余个不同品牌名称对外经营，实际出餐区域与后厨共用。",
    cover:
      "https://readdy.ai/api/search-image?query=Row%20of%20identical%20takeaway%20food%20containers%20stacked%20on%20a%20counter%2C%20dim%20corridor%20lighting%2C%20quiet%20late%20night%20mood%2C%20documentary%20photography%2C%20muted%20warm%20tones%2C%20high%20detail&width=800&height=600&seq=kedou-lead-kitchen-03&orientation=landscape",
    source: "匿名投稿 · 周边商户",
    date: "2026-08-14",
    readTime: "7 分钟",
    credibility: "verified",
    tags: ["外卖", "餐饮", "平台规则"],
    keyPoints: [
      "同一出餐地址在平台上对应 17 个不同品牌名称。",
      "不同品牌共用同一后厨与同一批操作人员。",
      "部分品牌使用的证照信息已过有效期。",
    ],
    content: [
      "这条线索来自一位在该片区经营多年的商户。他注意到，隔壁一处并不起眼的出餐点，几乎每天都有不同平台骑手排队取餐，但门口的招牌长期没有更换。",
      "我们随后进行了连续三周的实地观察。通过在平台检索同一地址，可以找到 17 个名称各异的品牌，品类从快餐到汤品不下十种，但取餐口始终是同一个。",
      "观察记录显示，不同品牌的订单由同一批工作人员打包，餐盒与包装袋会根据品牌分类摆放。后厨的出餐区域并未按品牌做物理隔离。",
      "我们还比对了平台公示的证照信息，其中若干品牌的食品经营许可已显示过期，但页面仍在正常营业。",
      "需要强调的是，多个品牌共用一个出餐点并不必然违规，关键取决于证照是否合规、加工是否隔离。本条内容聚焦于实地观察到的现象，相关判断建议以监管部门的认定为准。",
    ],
  },
  {
    id: "headhunter-fee",
    title: "「内推费」求职套路调查：付款后岗位即刻下架",
    category: "workplace",
    summary:
      "多位求职者反映，向所谓「内部推荐渠道」支付费用后，承诺的岗位很快被下架，对方随即失联。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20office%20desk%20with%20a%20laptop%20showing%20a%20blank%20screen%2C%20scattered%20resume%20papers%2C%20late%20afternoon%20window%20light%2C%20muted%20neutral%20tones%2C%20editorial%20documentary%20photography&width=800&height=600&seq=kedou-lead-job-04&orientation=landscape",
    source: "匿名投稿 · 求职者",
    date: "2026-08-06",
    readTime: "6 分钟",
    credibility: "cross",
    tags: ["招聘", "求职骗局", "付费内推"],
    keyPoints: [
      "收费方以「内部名额有限」制造紧迫感，要求先付款后沟通。",
      "付款后对应岗位链接在数小时内下架。",
      "多名求职者遇到相同的收款账户与话术模板。",
    ],
    content: [
      "投稿人去年毕业，在某求职社区看到一条「大厂内部推荐，名额有限」的信息。对方表示，只需支付一笔费用，就可以把简历直接推到用人部门负责人手中。",
      "在对方不断强调「明天名额就没了」的催促下，投稿人当天完成了转账。付款后，对方发来一段语音称「已经在走流程」，随后岗位链接便无法打开。",
      "此后的两周里，投稿人多次询问进展，对方以「HR 在休假」「流程卡在审批」为由拖延，最终不再回复。",
      "我们在整理线索时发现，至少还有四位求职者遇到了相同的收款账户与几乎一致的话术，其中包括「名额有限」「先付款再沟通」「推荐不成功不退款」。",
      "正规企业的内推通常不向求职者收费。本条内容提醒读者，遇到先付费的所谓「内推渠道」，应保持警惕并保留完整凭证。",
    ],
  },
  {
    id: "battery-refurb",
    title: "翻新电池流入售后市场：维修行业的成本账与来源疑点",
    category: "industry",
    summary:
      "从事新能源车维修的投稿人表示，部分售后渠道会用翻新电芯替代全新件，并在结算单上以新件价格计价。",
    cover:
      "https://readdy.ai/api/search-image?query=Disassembled%20battery%20modules%20on%20a%20workshop%20bench%20with%20diagnostic%20equipment%2C%20industrial%20grey%20tones%2C%20cool%20task%20lighting%2C%20technical%20documentary%20photography%2C%20detailed%20textures&width=800&height=600&seq=kedou-lead-battery-05&orientation=landscape",
    source: "匿名投稿 · 维修技师",
    date: "2026-07-30",
    readTime: "8 分钟",
    credibility: "pending",
    tags: ["新能源", "售后维修", "配件来源"],
    keyPoints: [
      "翻新电芯的采购成本与全新件存在明显差额。",
      "部分结算单据的配件编号与实物标签不一致。",
      "来源渠道仍需进一步核实。",
    ],
    content: [
      "投稿人在一家新能源车维修服务点工作。据其介绍，动力电池的售后更换涉及较大金额，配件的来源因此成为门店运营中的敏感环节。",
      "其提供的一份内部成本表显示，经过分选与重新配组的翻新电芯，采购价明显低于全新件，但在对外的结算单上，两者的计价方式被统一处理。",
      "投稿人还提到，部分配件的实物标签编号与结算单据上的编号存在出入，这一细节在内部曾引起过讨论。",
      "由于目前我们尚未取得可追溯的上游采购凭证，也未能确认相关配件的最终流向，本条线索暂时标记为「核实中」。欢迎掌握更多材料的读者继续补充。",
    ],
  },
  {
    id: "campus-study-room",
    title: "校园周边自习室押金纠纷集中：合同条款与实际情况不符",
    category: "campus",
    summary:
      "多名学生反映，校园周边自习室在退租时以各种理由扣留押金，且合同中的退还条件与前台口头承诺不一致。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20study%20room%20with%20rows%20of%20wooden%20desks%20and%20warm%20reading%20lamps%2C%20late%20evening%20ambience%2C%20soft%20golden%20light%2C%20calm%20editorial%20photography%2C%20gentle%20shadows&width=800&height=600&seq=kedou-lead-campus-06&orientation=landscape",
    source: "匿名投稿 · 在校学生",
    date: "2026-07-22",
    readTime: "6 分钟",
    credibility: "verified",
    tags: ["自习室", "押金", "格式合同"],
    keyPoints: [
      "前台口头承诺「随时可退」，合同却写明需提前 30 天申请。",
      "退租时以「桌位磨损」「清洁费」等名目扣款。",
      "同一门店近期集中出现相似投诉。",
    ],
    content: [
      "投稿人是某高校大二学生，上学期在校园周边一家自习室办理了季卡。办理时，前台明确表示押金「随时可以退，不住就退」。",
      "临近考试结束，投稿人提出退租，却被告知需要提前 30 天书面申请。查阅合同时才发现，条款中确实有这一行小字，而口头承诺并未写入合同。",
      "此后，投稿人又被以「桌位磨损」「集中清洁」等名目扣掉了一部分押金。在与其他同学交流后，投稿人发现至少有七八位使用者遇到类似情况。",
      "我们核对了投稿人提供的合同、付款记录与聊天记录，并联系到另外三位情况一致的学生，各方陈述可以相互印证。本条线索标记为「已核实」。",
    ],
  },
  {
    id: "training-refund",
    title: "职业培训机构「包就业」承诺：课程结束后的真实去向",
    category: "consumer",
    summary:
      "投稿人提供的班级群记录显示，机构承诺的「包就业」在实际执行中转变为推送招聘信息，学员退款诉求被长期搁置。",
    cover:
      "https://readdy.ai/api/search-image?query=Classroom%20with%20empty%20chairs%20and%20a%20whiteboard%20covered%20in%20faded%20notes%2C%20cool%20morning%20light%20through%20blinds%2C%20quiet%20documentary%20photography%2C%20muted%20neutral%20tones&width=800&height=600&seq=kedou-lead-training-07&orientation=landscape",
    source: "匿名投稿 · 结业学员",
    date: "2026-07-15",
    readTime: "7 分钟",
    credibility: "cross",
    tags: ["职业培训", "包就业", "退款"],
    keyPoints: [
      "招生阶段的「包就业」未在合同中写明具体标准。",
      "结业后实际提供的是通用招聘信息转发。",
      "多名学员的退款申请长期未获回应。",
    ],
    content: [
      "投稿人报名了一门为期四个月的职业技能课程。招生时，工作人员强调「学完包就业，不满意可退」，这句话是促使他付费的主要原因。",
      "课程结束后，机构开始在班级群里转发一些公开的招聘信息，并称这就是「就业服务」。投稿人希望按照当初的承诺申请退款，却始终没有得到明确答复。",
      "我们查看了投稿人提供的聊天群记录，其中至少还有五位学员表达了相同的诉求。招生阶段的话术截图与结业后的转发现状形成了鲜明对比。",
      "由于「包就业」的具体标准未落于书面合同，责任认定存在一定难度。本条线索标记为「多方印证」，并建议有类似经历的读者保留好招生阶段的宣传材料。",
    ],
  },
  {
    id: "eco-river",
    title: "河道周边环境观察：沿岸经营与水体变化的长期记录",
    category: "livelihood",
    summary:
      "投稿人提供了连续半年的沿岸影像记录，显示某河段周边经营活动与水体外观变化存在时间上的关联。",
    cover:
      "https://readdy.ai/api/search-image?query=Riverside%20path%20at%20dusk%20with%20quiet%20water%20and%20low%20vegetation%2C%20soft%20grey%20green%20tones%2C%20calm%20documentary%20photography%2C%20reflective%20water%20surface%2C%20muted%20atmosphere&width=800&height=600&seq=kedou-lead-river-08&orientation=landscape",
    source: "匿名投稿 · 周边居民",
    date: "2026-07-08",
    readTime: "7 分钟",
    credibility: "pending",
    tags: ["环境", "民生", "长期观察"],
    keyPoints: [
      "投稿人连续半年在同一位置进行定点拍摄。",
      "沿岸经营活动的时间与水体外观变化存在一定重合。",
      "尚需专业检测数据支撑结论。",
    ],
    content: [
      "投稿人居住在河段附近，从今年年初开始，他在每天早上几乎相同的时间、相同的位置拍摄一张照片，用来记录沿岸的变化。",
      "半年积累的影像显示，沿岸的经营摊位数量与水体外观的变化在时间上存在某种重合。投稿人希望通过平台，让更多人关注这一片区的日常环境状况。",
      "居民的主观观察值得记录，但环境议题的结论需要专业检测数据支撑。目前已将相关材料整理并标记为「核实中」，后续将寻求更专业的核实途径。",
      "我们也提醒读者，对于环境类线索，客观、长期、可复核的记录方式，远比单一时刻的激烈描述更有价值。",
    ],
  },
];

export const submissionSteps = [
  {
    step: "01",
    title: "提交线索",
    desc: "通过投稿表单描述事件经过，尽量附上时间、地点与可核对的材料。不确定的部分可以标注为「待确认」。",
    icon: "ri-edit-2-line",
  },
  {
    step: "02",
    title: "来源沟通",
    desc: "核实编辑会在 48 小时内与你取得联系，就关键细节做进一步确认，全程可由你决定沟通的深度与方式。",
    icon: "ri-chat-private-line",
  },
  {
    step: "03",
    title: "交叉核实",
    desc: "我们会寻找第二、第三来源相互印证，必要时联系相关方回应，并根据结果标注线索的可信度等级。",
    icon: "ri-checkbox-multiple-line",
  },
  {
    step: "04",
    title: "核实呈现",
    desc: "仅呈现可被验证的事实，投稿人信息默认匿名处理。你可以随时要求撤回尚未发布的线索。",
    icon: "ri-file-shield-2-line",
  },
];

export const faqs = [
  {
    q: "匿名投稿后，我的身份信息会被公开吗？",
    a: "不会。投稿人信息默认匿名处理，仅核实编辑在必要时与你单线沟通。我们不会在公开内容中披露任何可识别投稿人身份的信息，也不会将来源信息提供给第三方。",
  },
  {
    q: "什么样的线索适合投给蝌蚪爆料？",
    a: "与公共议题相关、具备可核实基础的真实经历都可以。包括消费维权、商业运作、职场见闻、行业观察等。纯个人纠纷若涉及公共利益，同样欢迎提供。",
  },
  {
    q: "提交线索需要提供哪些材料？",
    a: "时间、地点、事件经过是最基础的三要素。如果能有聊天记录、付款凭证、合同、照片或影像等可核对材料，会显著提升线索的核实效率。",
  },
  {
    q: "投稿后多久会得到反馈？",
    a: "核实编辑通常在 48 小时内与你取得联系。若线索材料充分，会在两周内完成初步核实并与你同步进展；未被采用的线索也会收到说明。",
  },
  {
    q: "线索核实过程中，我会承担风险吗？",
    a: "我们会在沟通开始前与你确认可接受的沟通方式与呈现范围。任何可能暴露你身份的细节，都会在发布前与你逐条确认。若你中途希望停止，可随时撤回。",
  },
  {
    q: "我可以指定线索的呈现方式吗？",
    a: "可以。包括是否匿名、是否模糊具体时间地点、是否保留原始材料的使用权，都可以在沟通中提出，我们会在合理范围内尊重你的选择。",
  },
];

export const testimonials = [
  {
    name: "李 —— 消费维权投稿人",
    role: "投稿后 11 天完成核实",
    text: "一开始很犹豫，怕信息被泄露。核实编辑先确认了我能接受的范围，每一步都会提前说明，最后发布出来的内容和我提供的原始材料一致。",
  },
  {
    name: "陈 —— 前从业者",
    role: "行业调查投稿人",
    text: "我在行业内待了很多年，知道哪些环节有问题但不知道怎么说。他们把我想表达的东西整理得很有条理，也没有夸大，这点让我放心。",
  },
  {
    name: "王 —— 订阅读者",
    role: "持续关注两年",
    text: "看这里的线索，最大的感受是克制。很多平台喜欢把话讲满，这里会把「还在核实」和「已经确认」分得很清楚，读起来更有判断依据。",
  },
];

export const contentPrinciples = [
  {
    title: "只呈现可核实的事实",
    desc: "所有对外发布的线索都会经过交叉印证，无法确认的部分会明确标注状态，绝不把推断当作结论。",
    icon: "ri-check-double-line",
  },
  {
    title: "来源信息严格保护",
    desc: "投稿人身份默认匿名，材料加密存储，访问权限最小化，从制度上避免来源暴露。",
    icon: "ri-lock-2-line",
  },
  {
    title: "给相关方回应空间",
    desc: "在发布涉及具体主体的线索前，我们会尽力联系对方，并在内容中呈现其回应的机会。",
    icon: "ri-chat-forward-line",
  },
  {
    title: "不追热点、不编情节",
    desc: "线索的价值不取决于热度，而取决于真实性。我们不会为了传播效果补全不存在的细节。",
    icon: "ri-quill-pen-line",
  },
];